import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
      Ne en kvardekaj apud Moskvo <br/>
      Sub la betul’, <br/>
      En okdek sesa li pereis <br/>
      Apud Kabul’.
      </p>

      <p class="poem-block mb-3">
      Patrinoj en la lando ploras <br/>
      Pro kies kulp’? <br/>
      Milito filojn jam devoras <br/>
      En blinda stult’.
      </p>

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        Obus’ eksplodis en funelo – <br/>
        Jen via sort’. <br/>
        Pro kio en la dom’ panela <br/>
        Alvenis mort’?
      </p>

      <p class="poem-block mb-3">
      Afgana vent’ okulojn ŝiras, <br/>
      Sed firmas man’. <br/>
      Kun la mitral’ post vi kaŝiras <br/>
      Murdist’-duŝman’.
      </p>

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf.</span>
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Afgana vento'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['BybrV6Bu-wI'],
    itemTranslator: `
      Teksto: N. Zinovjev, <br/>
      Muziko: I. Nikolaev, <br/>
      ${translator.esp}
    `
  }
}

export default item;